import React, { PureComponent } from 'react';
import { graphql } from 'react-apollo';

import resolver from '../../state/resolvers/event';
import { trackEventReviewed } from '../../utils/tracking';
import { GQLQueryPropType } from '../../proptypes';
import { UserQueryPublicBasic } from '../../state/services/gql/user';
import authService from '../../state/services/auth';

import EventReview from '../../components/EventReview';

/**
 * Event review container component.
 * Wraps the review component in state to control success screen.
 */
class EventReviewContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      response: undefined,
      success: false,
    };
  }

  handleFormSuccess = (response) => {
    trackEventReviewed(response.eventId, response.id);
    this.setState({
      response: {
        ...response,
        ...response.recommendedEvents && {
          recommendedEvents: response.recommendedEvents.map(resolver),
        },
      },
      success: true,
    }, () => {
      window.scrollTo(0, 0);
    });
  };

  render() {
    return (
      <EventReview
        onFormSuccess={this.handleFormSuccess}
        profile={this.props.data && this.props.data.profile}
        {...this.props}
        {...this.state}
      />
    );
  }
}

EventReviewContainer.propTypes = {
  /**
   * Data object from GraphQL query containing form.
   */
  data: GQLQueryPropType,
};

EventReviewContainer.defaultProps = {
  data: {},
};

export default graphql(
  UserQueryPublicBasic,
  {
    options: { variables: { id: authService.getUserCookie() } },
    skip: !authService.getUserCookie(),
  },
)(
  EventReviewContainer,
);



// WEBPACK FOOTER //
// ./app/src/containers/EventReview/index.jsx